<template>
  <div>
    <v-row>
      <v-data-table
        :headers="contactHeaders"
        :items="contactItems"
        sort-by="fName"
        class="elevation-1"
        :footer-props="{
            'items-per-page-text': $t('dataTable.rowsPerPageText'),
            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
        }"
        :no-data-text="$t('dataTable.noDataText')"
        :headerProps="{
            'sort-by-text': $t('dataTable.sortByText')
        }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-dialog v-model="dialog" max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >{{ $t("page.events.createRegistrant.emergencyContact.create_contact") }}</v-btn>
              </template>
              <v-card>
                <v-form ref="form">
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col md="12">
                          <v-text-field
                            v-model="form.firstName"
                            :label="$t('page.events.createRegistrant.emergencyContact.first_name')"
                            :rules="rules.firstName"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="12">
                          <v-text-field
                            v-model="form.lastName"
                            :label="$t('page.events.createRegistrant.emergencyContact.last_name')"
                            :rules="rules.lastName"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="6">
                          <v-text-field
                            v-model="form.homePhone"
                            :label="$t('page.events.createRegistrant.emergencyContact.home_phone')"
                            :rules="rules.homePhone"
                          ></v-text-field>
                        </v-col>
                        <v-col md="6">
                          <v-text-field
                            v-model="form.cellPhone"
                            :label="$t('page.events.createRegistrant.emergencyContact.cell_phone')"
                            :rules="rules.cellPhone"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="12">
                          <v-text-field
                            v-model="form.email"
                            type="email"
                            :label="$t('page.events.createRegistrant.emergencyContact.email')"
                            :rules="rules.email"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="createContact"
                      color="darken-1" dark small 
                      class="btn mb-2"
                      :disabled="!contactFormIsValid"
                    >{{ btnTitle }}</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <!--No se logro verificar-->
            <v-dialog v-model="dialogDelete" max-width="600px">
              <v-card>
                <v-card-title class="headline">{{ $t('page.events.createRegistrant.emergencyContact.delete_contact') }}</v-card-title>
                <v-card-text>
                  <p class="mt16">{{ $t('page.events.createRegistrant.emergencyContact.sure_delete') }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-row>
                    <v-col>
                      <v-btn
                        class="btn mb-2"
                        text
                        @click="closeDelete"
                      >{{ $t('page.events.createRegistrant.emergencyContact.cancel') }}</v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        color="primary"
                        class="btn mb-2"
                        text
                        @click="deleteItemConfirm"
                      >{{ $t('page.events.createRegistrant.emergencyContact.delete') }}</v-btn>
                    </v-col>
                  </v-row>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-row>
    <v-snackbar v-model="snackbar" timeout="3000" :color="color_snackbar">
      {{ msg_snackbar }}
      <template v-slot:action="{attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          <v-icon>fas fa-times-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
//import axios from "axios";
import EmergencyContactService from "../services/EmergencyContactService";
export default {
  name: "EmergencyContact",
  data() {
    const contactForm = Object.freeze({
      id: 0,
      firstName: "",
      lastName: "",
      homePhone: "",
      cellPhone: "",
      email: ""
    });
    return {
      snackbar: false,
      msg_snackbar: "",
      color_snackbar: "",
      dialog: false,
      editedIndex: -1,
      dialogDelete: false,
      contactForm,
      form: Object.assign({}, contactForm),
      rules: {
        firstName: [
          val =>
            (val || "").length > 0 ||
            this.$t("page.events.createRegistrant.emergencyContact.first_name_required")
        ],
        lastName: [
          val =>
            (val || "").length > 0 ||
            this.$t("page.events.createRegistrant.emergencyContact.last_name_required")
        ],
        homePhone: [
          val =>
            (val || "").length > 0 ||
            this.$t("page.events.createRegistrant.emergencyContact.home_phone_required")
        ],
        cellPhone: [
          val =>
            (val || "").length > 0 ||
            this.$t("page.events.createRegistrant.emergencyContact.cell_phone_required")
        ],
        email: [
          val =>
            (val || "").length > 0 || this.$t("page.events.createRegistrant.emergencyContact.email_required")
        ]
      },
      contactHeaders: [
        {
          text: this.$t("page.events.createRegistrant.emergencyContact.first_name"),
          align: "",
          sortable: false,
          value: "fName"
        },
        { text: this.$t("page.events.createRegistrant.emergencyContact.last_name"), value: "lName" },
        { text: this.$t("page.events.createRegistrant.emergencyContact.home_phone"), value: "homePhone" },
        { text: this.$t("page.events.createRegistrant.emergencyContact.cell_phone"), value: "cellPhone" },
        { text: this.$t("page.events.createRegistrant.emergencyContact.email"), value: "email" },
        {
          text: this.$t("page.events.createRegistrant.emergencyContact.actions"),
          value: "actions",
          sortable: false
        }
      ],
      contactItems: [],
      defaultItem: {
        firstName: "",
        lastName: "",
        homePhone: "",
        cellPhone: "",
        email: ""
      }
    };
  },
  mounted() {
    this.getEmergencyContacts();
  },
  computed: {
    contactFormIsValid() {
      return (
        this.form.firstName &&
        this.form.lastName &&
        this.form.homePhone &&
        this.form.cellPhone &&
        this.form.email
      );
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("page.events.createRegistrant.emergencyContact.create_contact")
        : this.$t("page.events.createRegistrant.emergencyContact.edit_contact");
    },
    btnTitle() {
      return this.editedIndex === -1
        ? this.$t("page.events.createRegistrant.emergencyContact.create")
        : this.$t("page.events.createRegistrant.emergencyContact.edit");
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    }
  },
  methods: {
    async getEmergencyContacts() {
      EmergencyContactService.getAll().then(response => {
        if (response.data.success == 1) {
          this.contactItems = response.data.message.data;
        }
      });
    },
    setEmergencyContact(data) {
      EmergencyContactService.create(data).then(response => {
        if (response.data.success == 1) {
          this.contactItems = [];
          this.getEmergencyContacts();
          this.msg_snackbar = this.$t("page.events.createRegistrant.emergencyContact.msg_success_created");
          this.snackbar = true;
          this.color_snackbar = "success";
        }
      });
    },
    deleteEmergencyContact(id) {
      EmergencyContactService.delete(id).then(response => {
        if (response.data.success == 1) {
          this.contactItems = [];
          this.getEmergencyContacts();
          this.msg_snackbar = this.$t("page.events.createRegistrant.emergencyContact.msg_success_deleted");
          this.snackbar = true;
          this.color_snackbar = "success";
        }
      });
    },
    editEmergencyContact(data) {
      EmergencyContactService.update(data).then(response => {
        if (response.data.success == 1) {
          this.contactItems = [];
          this.getEmergencyContacts();
          this.msg_snackbar = this.$t("page.events.createRegistrant.emergencyContact.msg_success_edited");
          this.snackbar = true;
          this.color_snackbar = "success";
        }
      });
    },
    editItem(item) {
      this.editedIndex = this.contactItems.indexOf(item);
      this.form = Object.assign({}, item);
      this.form.firstName = item.fName;
      this.form.lastName = item.lName;
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.contactItems.indexOf(item);
      this.form = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      //this.contactItems.splice(this.editedIndex, 1);
      this.deleteEmergencyContact(this.form.id);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    createContact() {
      if (this.editedIndex > -1) {
        this.editEmergencyContact(this.form);
      } else {
        this.setEmergencyContact(this.form);
      }
      this.close();
    }
  }
};
</script>
<style>
.v-data-table-header,
.v-card__title {
  background: #ccc;
}
.v-data-table {
  width: 100%;
  margin: 20px;
}
.mt16 {
  margin-top: 16px;
}
</style>